// @ts-check

import ResetGridLink from "~/components/Shared/DataGrid/ResetGridLink";
import { useIncidentTemplateDataGridContext } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.utils';

export default function ResetIncidentTemplateGridLink() {
    const { settings } = useIncidentTemplateDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}            
        />
    );
} 